<app-loader></app-loader>
<router-outlet></router-outlet>

<a href="https://wa.me/739085575?text=Hello!%20I%20would%20like%20to%20know%20more%20about%20your%20services" 
   class="whatsapp-float" 
   target="_blank">
    <img src="assets/images/whatsapp-icon.png" alt="WhatsApp Chat" />
</a>

<style>
    .whatsapp-float {
        position: fixed;    
        width: 60px;
        height: 60px;
        bottom: 40px;
        right: 40px;
        background-color: #25d366;
        color: #FFF;
        border-radius: 50px;
        text-align: center;
        font-size: 30px;
        box-shadow: 2px 2px 3px #999;
        z-index: 100;
    }
    

    .whatsapp-float img {
        width: 40px;
        height: 40px;
        margin-top: 10px;
    }
</style>
